import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import type { ObjectFieldValues } from "../../../../api/types/objectTypes";
import type { ChecklistConfigurationState } from "./checklistConfigurationState";
import { moveTaskAction, removeTaskAction } from "./checklistConfigurationState";

interface Props {
  state: ChecklistConfigurationState;
  setState: Dispatch<SetStateAction<ChecklistConfigurationState>>;
  taskTemplates: ObjectFieldValues[];
}

const ChecklistTasksTable = ({ state, setState, taskTemplates }: Props) => {
  if (state.form.taskTemplateIds.length === 0) {
    return null;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Category</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {state.form.taskTemplateIds.map((id, index) => {
          const taskTemplate = taskTemplates.find((t) => t.id === id);
          if (!taskTemplate) {
            return null;
          }

          return (
            <TableRow key={id}>
              <TableCell>{taskTemplate.displayValues.primaryValue}</TableCell>
              <TableCell>{taskTemplate.displayValues.secondaryValue}</TableCell>
              <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                <IconButton size="small" onClick={() => setState(moveTaskAction(index, "up"))} disabled={index === 0}>
                  <ArrowUpwardRoundedIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => setState(moveTaskAction(index, "down"))}
                  disabled={index === state.form.taskTemplateIds.length - 1}
                >
                  <ArrowDownwardRoundedIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={() => setState(removeTaskAction(id))}>
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ChecklistTasksTable;
